/** Checkout key always comes from backend (paymentStepOne). Switch test/live in backend .env only. */
export const getRazorpayCheckoutKey = (paymentData) => {
  const key = paymentData?.razorpayKeyId;
  if (!key) {
    throw new Error("Payment is not configured. Please contact support.");
  }
  return key;
};
